module.exports = __webpack_public_path__ + "static/media/Subtract.7f2051bd.svg";